import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useBenefits } from '../BenefitsProvider'
import { Modal, Stack } from '~/components/_layouts'
import { UserIcon } from '@heroicons/react/24/outline'
import { Button } from '~/lib/ui/button'
import ScheduleInner from './ScheduleInner'

const ScheduleDialog = ({
  services,
  current_user,
  coach,
  flexResumeReview,
}) => {
  const {
    showScheduleDialog,
    toggleShowScheduleDialog,
    showBackButton,
    dialogTitle,
    page,
    handleBack,
    serviceRequestType,
    select,
  } = useBenefits()
  const { t } = useTranslation()

  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          {dialogTitle}
        </Stack>
      }
      variant={select ? 'primary' : 'secondary'}
      size="md"
      open={showScheduleDialog}
      fullHeight
      onClose={() => toggleShowScheduleDialog()}
      actions={
        page === 2 && (
          <div className="flex w-full justify-center">
            {!(
              flexResumeReview &&
              serviceRequestType === 'ServiceRequest::ResumeReview'
            ) &&
              showBackButton && (
                <Button
                  variant={select ? 'default' : 'coachcta'}
                  onClick={handleBack}
                >
                  {t('schedule_modal.back_button')}
                </Button>
              )}
          </div>
        )
      }
    >
      <ScheduleInner
        current_user={current_user}
        services={services}
        coach={coach}
      />
    </Modal>
  )
}

export default ScheduleDialog
